import {
  Accordion,
  Button,
  customScrollMinimal,
  SkeletonLoader,
  typographyV2,
  values,
} from '@toggle/design-system';
import { styled } from 'styled-components';

export const INVENTORY_WIDTH = '368px';

export const SidebarContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  height: calc(100% - var(--app-header-height));
  width: ${INVENTORY_WIDTH};
  display: flex;
  flex-direction: column;
  flex: 0 0 ${INVENTORY_WIDTH};
  flex-shrink: 0;
  padding: 20px 16px;
  border-left: 1px solid var(--border-soft);
  background-color: var(--background-default);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  z-index: var(--z-index-sidebar);
  ${customScrollMinimal}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  ${typographyV2.titleBase};
`;

export const StyledAccordion = styled(Accordion)`
  ${Accordion.Styled.AccordionItem} {
    background-color: var(--background-default);
    border-bottom-left-radius: ${values.r2};
    border-bottom-right-radius: ${values.r2};
    border: 1px solid var(--border-soft);
    margin-bottom: 12px;

    &:hover {
      background-color: unset;
    }

    &.accordion-expanded {
      margin-bottom: 32px;
    }
  }

  ${Accordion.Styled.TitleContainer} {
    padding: 6px 8px;
    color: var(--text-soft);
    border-top-left-radius: ${values.r2};
    border-top-right-radius: ${values.r2};
    border: 1px solid var(--border-soft);
    ${typographyV2.bodySm};
    background-color: var(--surface-default);
  }

  ${Accordion.Styled.Content} {
    padding: 0;
  }

  ${Accordion.Styled.IconStyled} {
    width: 12px;
    height: 12px;
    fill: var(--icon-soft);
  }
`;

export const AccordionItemLoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '20px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const TimeSeriesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TimeSeriesTitle = styled.span`
  margin-right: 160px;
`;

export const PlotButton = styled(Button)`
  height: 20px;
  width: 40px;
`;

export const BadgeTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: var(--surface-active);
  color: var(--text-soft);
  ${typographyV2.bodyXs};
`;
